module.exports = __webpack_public_path__ + "11138a8520e993cea983ccc2ab76e20f.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_1-660.webp
// module id = 287
// module chunks = 0